import {RE_FAILURE, RE_PENDING, RE_SUCCESS} from './constants'
import resourcesJson from '../../../fixtures//reservations_calendar_events.json'
import _ from 'lodash'

const getReservationResources = ({q = null}) => {
  return async dispatch => {
    dispatch({type: RE_PENDING})
    try {
      // const response = await getReservationResources()
      let resources = _.clone(resourcesJson.resources)
      if (q) {
        resources = _.filter(resources, e => e.name.toLowerCase().indexOf(q.toLowerCase()) !== -1)
      }
      dispatch({type: RE_SUCCESS, payload: {data: resources}})
    } catch (e) {
      console.log(`Get reservation resources Failed: ${e}`)
      dispatch({type: RE_FAILURE, payload: e})
    }
  }
}

export default getReservationResources
